/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {TitleOutlined} from "@mui/icons-material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {useIngresarObjeto} from "../../Modulo_formularios/Hooks/useIngresarObjeto";
import Tarjeta_Especificacion from "../Tarjetas/Tarjeta_Especificacion";
import Formulario_Tours_Tarjeta_Especificacion from "./Formulario_Tours_Tarjeta_Especificacion";
import IngresoTextoLista from "../../Modulo_formularios/Componentes/IngresoTextoLista";


const Formulario_Tours_Incluye = ({...props}) => {



    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={12}>
                    <IngresoTexto Icono={TitleOutlined} nombre={'Nombre del tour'}
                                  dato={'nombre'} {...props} editable={false}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Servicios o Articulos que Incluyen en el tour</Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTextoLista lineas={3}  {...props} nombre={'Incluyen'}
                                        dato={'incluidos'}/>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Tours_Incluye